import { Link } from "react-router-dom";
import { ArrowLeft, Anchor } from "lucide-react";
import { BRAND } from "../lib/constants";

export const NotFound = () => {
  return (
    <main
      data-testid="not-found"
      className="min-h-screen bg-[#061426] text-white flex items-center justify-center px-6 py-20 grain relative overflow-hidden"
    >
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute -top-32 -right-32 w-[28rem] h-[28rem] border border-[#C8A24A]/20 rotate-12" />
        <div className="absolute -bottom-40 -left-32 w-[32rem] h-[32rem] border border-[#C8A24A]/15 rotate-45" />
      </div>

      <div className="relative max-w-2xl text-center">
        <div className="flex items-center justify-center gap-4 mb-10">
          <img
            src={BRAND.logo}
            alt="Sardaar Stevedoring"
            className="h-14 w-14 object-contain bg-white p-1.5"
          />
        </div>

        <div className="flex items-center justify-center gap-3 mb-8 text-[#C8A24A]">
          <span className="gold-line" />
          <Anchor size={16} />
          <span className="font-sans uppercase text-xs tracking-widest-2">
            Off Course
          </span>
          <span className="gold-line" />
        </div>

        <h1 className="font-serif text-7xl md:text-8xl font-bold mb-6 leading-none">
          404
        </h1>
        <p className="font-serif text-2xl md:text-3xl mb-4 italic">
          This consignment seems to have lost its bearing.
        </p>
        <p className="font-sans text-white/65 text-base md:text-lg mb-12 leading-relaxed">
          The page you're looking for has either been moved, never existed, or
          drifted out of port. Let's get you back to home waters.
        </p>

        <Link
          to="/"
          data-testid="not-found-home-link"
          className="inline-flex items-center gap-3 bg-[#C8A24A] text-[#0B2545] font-bold px-8 py-4 uppercase text-sm tracking-widest-2 hover:bg-[#D4AF37] transition-colors"
        >
          <ArrowLeft size={16} /> Return to Home
        </Link>
      </div>
    </main>
  );
};
